/**
 * Cable Tray / Conduit Fitting Tool - Fitting Placement
 *
 * BIM Systems > Electrical > "Cable Tray / Conduit Fittings": manually
 * places elbows, tees and crosses on cable tray and conduit runs. Mirrors
 * DuctFittingTool: click-click placement on the work plane with a ghost
 * preview following the cursor.
 */

import { v4 as uuidv4 } from 'uuid';
import { Element } from '../core/types';
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';
import * as THREE from 'three';

export interface TrayConduitFittingGeometryData {
    position: [number, number, number];
    rotation: number;
}

export interface TrayConduitFittingElement extends Element {
    category: 'Cable Tray Fittings';
    geometryData: TrayConduitFittingGeometryData;
}

export class TrayConduitFittingTool extends BaseTool {
    id = 'tray_conduit_fitting';
    name = 'Cable Tray / Conduit Fitting';
    cursor = 'crosshair';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        const point = this.getIntersection(event);
        if (!point) return;

        const snapped = this.snapToGrid(point);
        this.createFitting(snapped);
    }

    onPointerMove(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        const point = this.getIntersection(event);
        if (point) {
            const snapped = this.snapToGrid(point);
            this.context.appStore.setToolPreview({
                type: 'fitting_tray',
                position: snapped
            });
        }
    }

    onPointerUp(_event: ThreeEvent<PointerEvent>): void { }

    private createFitting(point: THREE.Vector3) {
        if (!this.context) return;

        const geometryData: TrayConduitFittingGeometryData = {
            position: [point.x, point.y, point.z],
            rotation: 0
        };

        const fitting: TrayConduitFittingElement = {
            id: uuidv4(),
            category: 'Cable Tray Fittings',
            type: 'Standard Elbow - Inside 90',
            parameters: {
                'Size': '300x100 mm',
                'Angle': '90°'
            },
            constraints: [],
            geometryData
        };

        this.context.bimStore.addElement(fitting);
    }
}
